module.exports = __webpack_public_path__ + "static/img/9.b5cb42d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/sp/9.png
// module id = eWeC
// module chunks = 0